/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PregnancyPeriod {
    INITIAL = 'initial',
    OPTIONAL = 'optional',
    FOR28WEEKS = 'for28Weeks',
    FOR36WEEKS = 'for36Weeks',
}
